var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.parsedScore > 0 )?_c('div',{staticClass:"star-rating"},[_vm._l((_vm.parsedScore),function(n){return _c('i',{key:'active' + n,staticClass:"icon-star"})}),_vm._v(" "),_vm._l((_vm.inactiveCount),function(i){return _c('i',{key:'inactive' + i,staticClass:"icon-star inactive"})})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3390c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/star-rating.vue
// module id = null
// module chunks = 